import axios from "axios";
import { withSkipGlobalError } from "@/lib/http/skip-global-error";
import { editorHeaders } from "../sacred-library/sacred-library-api";
import { getApiBaseUrl } from "@/lib/api-base";

const API = getApiBaseUrl();

export function pageAssetUrl(slug) {
  return `${API}/pages/asset/${slug}`;
}

export async function fetchPublishedPage(slug) {
  const res = await axios.get(
    `${API}/pages/${encodeURIComponent(slug)}`,
    withSkipGlobalError()
  );
  return res.data;
}

export async function fetchPageForEditor(slug) {
  const res = await axios.get(
    `${API}/pages/${encodeURIComponent(slug)}`,
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export async function savePage(slug, payload) {
  const res = await axios.put(
    `${API}/pages/${encodeURIComponent(slug)}`,
    payload,
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export async function submitPage(slug, page) {
  const res = await axios.post(
    `${API}/pages/${encodeURIComponent(slug)}/submit`,
    { page },
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export async function publishPage(slug, page) {
  const res = await axios.post(
    `${API}/pages/${encodeURIComponent(slug)}/publish`,
    { page },
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export async function uploadPageImage(slug, dataBase64, mime) {
  const res = await axios.post(
    `${API}/pages/${encodeURIComponent(slug)}/image`,
    { data_base64: dataBase64, mime, target: "hero" },
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export async function fetchPagesIndex() {
  const res = await axios.get(`${API}/pages`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data.pages ?? [];
}

export async function resetPage(slug) {
  const res = await axios.post(
    `${API}/pages/${encodeURIComponent(slug)}/reset`,
    {},
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export async function deletePage(slug) {
  const res = await axios.delete(
    `${API}/pages/${encodeURIComponent(slug)}`,
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export { API };
